module.exports = __webpack_public_path__ + "img/20210823_123655.c8e77cfc.jpg";